export const EventFormatType = {
    TIME_BASED: "TIME_BASED",
    POINTS_BASED: "POINTS_BASED",
    TIME_POINTS_BASED: "TIME_POINTS_BASED",
}